var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{ rating: true, [`rating-${_vm.size}`]: _vm.size }},[_vm._v("\n  "+_vm._s(_vm.rating)+"\n  "),_c('i',{staticClass:"la la-star"})])
}
var staticRenderFns = []

export { render, staticRenderFns }